export const orgId = "climatesolutions"

// const url = "http://localhost:5000/" + orgId + "/"
const url = "https://beta.blissbookstore.in/" + orgId + "/"

export const productsUrl = url + "products/"
export const couponsUrl = url + "coupons/"
export const searchUrl = url + "products/search/"
export const ordersUrl = url + "orders/"